import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: ()=> import('@/views/index.vue')
  },
  {
    path: '/card',
    name: 'index',
    component: ()=> import('@/views/index.vue')
  },
  {
    path: '/gift',
    name: 'index',
    component: ()=> import('@/views/index.vue')
  },
  {
    path: '/sell',
    name: 'index',
    component: ()=> import('@/views/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
